import { SortingRule } from 'react-table';
import * as DT from '../datatable';
import { State, FilterCriteria, Customer } from './model';
import { getPK } from './utils';
import * as Devices from '../devices';
import { criterionNames } from '../../interfaces';

export const FilterCriteriaDefault: FilterCriteria = {
  owner: '',
  deviceStatus: Devices.Statuses.Active,
};

export const SelectionDefault: DT.ItemSelection<Customer> = {
  isAllSelected: false,
  selectedKeys: [],
  getPK,
};

export const DataDefault: DT.IData<Customer> = {
  pages: [],
  pageSize: 50,
  total: 0,
  version: 0,
};

export const TablePaginationDefault: DT.TablePagination = {
  currentPage: 1,
  numPages: 1,
  pageSize: 15,
};

export const TableDefault: DT.ITable<Customer> = {
  content: [],
  isLoading: false,
  pagination: TablePaginationDefault,
  columns: [],
};

export const SortDefault: SortingRule = {
  id: criterionNames.owner,
  desc: true,
};

export const StateDefault: State = {
  filters: FilterCriteriaDefault,
  sort: [SortDefault],
  selection: SelectionDefault,
  data: DataDefault,
  table: TableDefault,
  pagesToLoad: [1],
};
